<template>
  <button @click="$emit('click')" class="bg-blue-600 hover:bg-blue-500 font-semibold transform duration-200 rounded shadow px-3 py-2 text-sm text-white">{{ text }}</button>
</template>

<script>
export default {
  props: ['text']
}
</script>
